import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./style.css";
import { installAuthFetchInterceptor } from "./auth";

// Attach the Authorization header to every API call before the app mounts.
installAuthFetchInterceptor();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
